import translations from '../../../translations';
import type { DispatchFlowConfiguration } from './reducer';

interface Props {
    translationNotes: string;
    dispatchFlowConfiguration: DispatchFlowConfiguration;
}

const FlowTranslationNotes = ({ translationNotes, dispatchFlowConfiguration }: Props) => (
    <>
        <h2>{translations.TRANSLATIONS_notes_header}</h2>
        <textarea
            id="flow-translation-notes"
            className="form-control form-control-textarea translation-notes"
            value={translationNotes}
            onChange={({ target }) => {
                dispatchFlowConfiguration({
                    type: 'updateTranslationNotes',
                    payload: { translationNotes: target.value },
                });
            }}
            placeholder={translations.TRANSLATIONS_notes_placeholder}
        />
        <span className="help-block">{translations.TRANSLATIONS_notes_help_text}</span>
    </>
);

export default FlowTranslationNotes;
